import React from 'react';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';

const CustomRatingComponent = ({ name, defaultValue, precision, onChange, value }) => {
  return (
    <Rating
      name={name}
      value={value}
      precision={precision}
      defaultValue={defaultValue}
      onChange={(e, newValue) => onChange(newValue)}
      emptyIcon={<StarBorderIcon fontSize="inherit" />}
    />
  );
};

export const CustomRating = React.memo(CustomRatingComponent);
